export default __webpack_public_path__ + "static/media/footerBackground.13f9ad0b.svg";